import React, { useState } from 'react';
import { Row, Col, Button, Dropdown, Drawer } from "antd";
import { Link, useNavigate , useLocation } from "react-router-dom";
import type { MenuProps } from 'antd';
import axios from "axios";
import { MenuOutlined, DownOutlined } from '@ant-design/icons';
import logo from "../assets/logo.svg";
import '../assets/header.scss';

function Header() {
  const [isShowMenu, setIsShowMenu] = useState(false);

  let user = JSON.parse(localStorage.getItem("user_info")!);
  let navigate = useNavigate();
  const location = useLocation();

  const goToLoginPage = () => {
    navigate("/login");
  };

  const handleGotoHealthCheck = () => {
    document.location.href = '/tools/sktccn';
  }

  const handleGotoEkyc = () => {
    document.location.href = '/tools/skdm'
  }

  const handleGotoEkyc2 = () => {
    navigate("/");
  }

  const handleLogOut = () => {
    localStorage.clear();
    axios.defaults.headers.common["Authorization"] = "";
    navigate("/login");
  }

  const handleOpenMenu = () => {
    setIsShowMenu(true)
  }

  const handleCloseMenu = () => {
    setIsShowMenu(false)
  }

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div onClick={() => handleLogOut()}>
          Đăng xuất
        </div>
      ),
    },
  ];

  const toolItems: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <a onClick={() => handleGotoHealthCheck()}>Khám SK TCCN</a>
      ),
    },
    {
      key: '2',
      label: (
        <a onClick={() => handleGotoEkyc()}>Khám Danh mục đầu tư</a>
      ),
    },
    // {
    //   key: '3',
    //   label: (
    //     <a onClick={() => handleGotoEkyc2()}>Khám Danh mục đầu tư 2</a>
    //   ),
    // },
  ];
  
  return (
    <header id="root-header" className="header-page">
      <div className="container header-container">
        <Row justify="space-between" align="middle" style={{ height:'60px' }}>
          <Col span={4}>
            <Link to="https://finpeace.vn/" target="_blank">
              <img className="header-logo" src={logo} alt="logo" />
            </Link>
          </Col>
          <Col span={20}>
            <div className="menu">
              <Row justify="end" align="middle" gutter={16}>
                <Col flex="100px">
                  <Link to="https://finpeace.vn/" target="_blank" className="header-link">Trang chủ</Link>
                </Col>
                <Col flex="120px">
                  <Link to="https://finpeace.vn/ve-chung-toi/" target="_blank" className="header-link">Về chúng tôi</Link>
                </Col>
                <Col flex="100px">
                  <Link to="https://finpeace.vn/khoa-hoc/" target="_blank" className="header-link">Khoá học</Link>
                </Col>
                <Col flex="100px">
                  <Link to="https://lms.finpeace.vn/dang-nhap" target="_blank" className="header-link">Đào tạo</Link>
                </Col>
                <Col flex="100px">
                  <Link to="/" className={`header-link ${location.pathname.includes('stockpicks') ? 'active' : ''}`}>StockPicks</Link>
                </Col>
                <Col flex="100px">
                  <Dropdown menu={{ items: toolItems }} placement="bottom" arrow>
                    <span className='header-link have-click'>Công cụ</span>
                  </Dropdown>
                </Col>
                {user ? (
                  <>
                    <Col flex="150px">
                      <Dropdown menu={{ items }} placement="bottomLeft" arrow>
                        <Button className='btn-register logined'>
                          <span>{`Xin chào, ${user?.full_name}`}</span>
                        </Button>
                      </Dropdown>
                    </Col>
                  </>) : (
                  <>
                    <Col flex="100px">
                      <Link to="/register" className={`header-link ${location.pathname.includes('register') ? 'active' : ''}`}>Đăng ký</Link>
                    </Col>
                    <Col flex="150px">
                      <Button className='btn-register' onClick={goToLoginPage}>
                        <span>Đăng nhập</span>
                      </Button>
                    </Col>
                  </>
                )}
              </Row>
            </div>
            <div className="menu-mobile">
              <Row justify="end" align="middle">
                <Col flex="40px">
                  <Button className='btn-menu' icon={<MenuOutlined />} onClick={handleOpenMenu}></Button>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
      <Drawer title={user ? `Xin chào, ${user.full_name}` : 'Danh sách'} placement="right" onClose={handleCloseMenu} open={isShowMenu} size='default' className='drawer-menu'>
        <Link to="https://finpeace.vn/" target="_blank" className="header-link">Trang chủ</Link>
        <Link to="https://finpeace.vn/ve-chung-toi/" target="_blank" className="header-link">Về chúng tôi</Link>
        <Link to="https://finpeace.vn/khoa-hoc/" target="_blank" className="header-link">Khoá học</Link>
        <Link to="https://lms.finpeace.vn/dang-nhap" target="_blank" className="header-link">Đào tạo</Link>
        <Link to="/" className={`header-link ${location.pathname.includes('stockpicks') ? 'active' : ''}`}>StockPicks</Link>
        <Dropdown menu={{ items: toolItems }} placement="bottomLeft" arrow>
          <span className='header-link have-click' style={{ cursor: 'pointer'}}>Công cụ</span>
          {/* <DownOutlined /> */}
        </Dropdown>
        {user ? (
          <>
            <a className="header-link" onClick={() => handleLogOut()}>
              Đăng xuất
            </a>
          </>
        ) : (
          <>
            <Link to="/login" className="header-link">Đăng nhập</Link>
            <Link to="/register" className="header-link">Đăng ký</Link>
          </>
        )}
      </Drawer>
    </header>
  );
}

export default React.memo(Header);